mutation CreateAutomation($input: CreateAutomationInput!) {
  createAutomation(input: $input) {
    id
  }
}
